export const NOTIFICATION__SAVE = 'NOTIFICATION__SAVE';
export const NOTIFICATION__SEARCH = 'NOTIFICATION__SEARCH';
export const NOTIFICATION__SEARCH_FULFILLED = 'NOTIFICATION__SEARCH_FULFILLED';
export const NOTIFICATIONS__LOAD_ALL = 'NOTIFICATIONS__LOAD_ALL';
export const NOTIFICATIONS__LOAD_ALL_PENDING =
  'NOTIFICATIONS__LOAD_ALL_PENDING';
export const NOTIFICATIONS__LOAD_ALL_FULFILLED =
  'NOTIFICATIONS__LOAD_ALL_FULFILLED';
export const NOTIFICATION__DELETE = 'NOTIFICATION__DELETE';
